import React from 'react';
import { Stack } from '@mui/material';

import { KioskImageSetFragment } from '@occc/graphql';

import { ImagePreviewCard } from './image-preview-card';
import { KioskPreview } from './kiosk-preview.component';

import { ipadBackground, androidBackground } from '../images';

type AssetImagePreviewProps = {
  imageSet: KioskImageSetFragment;
};

export const AssetImagePreview = ({ imageSet }: AssetImagePreviewProps) => {
  const { landscape, square, portrait } = imageSet;

  return (
    <Stack
      direction={{ xs: 'column', sm: 'row' }}
      spacing={{ xs: 4, sm: 0 }}
      justifyContent={{ xs: 'flex-start', sm: 'space-between' }}
      alignItems={{ xs: 'flex-start', sm: 'center' }}
      flexWrap='wrap'
    >
      {!landscape && !square && !portrait ? (
        <>
          <ImagePreviewCard aspectRatio='4x3' backgroundImage={ipadBackground} />
          <ImagePreviewCard aspectRatio='1x1' backgroundImage={ipadBackground} />
          <ImagePreviewCard aspectRatio='9x16' backgroundImage={androidBackground} />
        </>
      ) : (
        <>
          <ImagePreviewCard
            aspectRatio='4x3'
            imageUrl={landscape}
            altText='Landscape Image (4x3)'
            backgroundImage={ipadBackground}
          />

          <ImagePreviewCard
            aspectRatio='1x1'
            imageUrl={square}
            altText='Square Image (1x1)'
            backgroundImage={ipadBackground}
          >
            <KioskPreview imageUrl={square} />
          </ImagePreviewCard>

          <ImagePreviewCard
            aspectRatio='9x16'
            imageUrl={portrait}
            altText='Portrait Image (9x16)'
            backgroundImage={androidBackground}
          />
        </>
      )}
    </Stack>
  );
};
